import AntdSelect from "antd/lib/select";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { SelectPlaceholder, SelectPrefix, SelectWrapper } from "./elements";
import "./index.sass";

const Select = ({ prefixIcon, selectPlaceholder, value, "data-testid": dataTestId, ...props }) => {
	const [hasValue, setHasValue] = useState(!!value);
	const wrapperRef = useRef(null);

	const applyTextTestId = useCallback(() => {
		const el = wrapperRef.current;
		if (!dataTestId || !el || !el.querySelector) return;
		const item = el.querySelector(".ant-select-selection-item");
		if (item) {
			item.setAttribute("data-testid", `${dataTestId}-text`);
		}
	}, [dataTestId]);

	useEffect(() => {
		const el = wrapperRef.current;
		if (!dataTestId || !el || !el.querySelector) return;
		applyTextTestId();
		const observer = new MutationObserver(applyTextTestId);
		observer.observe(el, { childList: true, subtree: true });
		return () => observer.disconnect();
	}, [dataTestId, applyTextTestId]);

	const onFocus = (event) => {
		event.target.setAttribute("autocomplete", "none");
	};

	const handleSelectChange = (value, option) => {
		setHasValue(!!value);
		const hasValueClass = value ? "has-value" : "";
		option.className = `${option.className} ${hasValueClass}`;
	};

	return (
		<SelectWrapper innerRef={wrapperRef}>
			{prefixIcon && (
				<SelectPrefix className="prefix-icon-wrapper">{prefixIcon}</SelectPrefix>
			)}
			{!hasValue && selectPlaceholder && (
				<SelectPlaceholder className="select-placeholder">
					{selectPlaceholder}
				</SelectPlaceholder>
			)}
			<AntdSelect
				data-testid={dataTestId}
				onFocus={onFocus}
				onChange={handleSelectChange}
				value={value}
				{...props}
			/>
		</SelectWrapper>
	);
};

Select.Option = AntdSelect.Option;
export default Select;
